import { Flex } from 'antd';
import { Button } from 'antd';
import React from "react";
import { Link } from 'react-router-dom';

function Switcher(){
    return(
        <Flex
          className="w-fit my-[2vh] mr-[4vh] max-w-[60vw] relative transform-gpu"
        >
            <Link to="/audios">
                <Button type='primary'
                    className="m-[5px] font-['Optimistic'] font-bold skew-x-[-10deg] bg-AronaH hover:bg-PuranaLite">
                    多媒体
                </Button>
            </Link>
            <Link to="/timelines">
                <Button type='primary'
                    className="m-[5px] font-['Optimistic'] font-bold skew-x-[-10deg] bg-AronaH hover:bg-PuranaLite">
                    时间线
            </Button></Link>
        </Flex>
    )
}

export default Switcher;
